@if (moduleService.moduleContent) {
  <div class="fields-container"
    >
    @for (fieldGroup of moduleService.fieldGroups; track groupTrackBy($index, fieldGroup)) {
      <div>
        <mat-panel-title>
          <h4>
            {{fieldGroup.UiGroupName | translate: 'Text' | async }}
            <a id="delete-field-group-{{fieldGroup}}" mat-raised-button class="mat-warn tableBtn" [disabled]="!canDeleteFieldGroup(fieldGroup.GroupName)" (click)="deleteGroupName(fieldGroup.GroupName)">
              <mat-icon>delete</mat-icon>
            </a>
          </h4>
        </mat-panel-title>
        @for (field of moduleService.fields| fieldGroupFilter:[fieldGroup.UiGroupName, fieldFilter]; track trackByField($index, field)) {
          <div class="field-container"
            [ngClass]="{'field-hidden': field.IsAlwaysHidden}">
            <div class="left-controls">
              Hidden
              @if (!field.IsMandatory) {
                <mat-slide-toggle [disabled]="!moduleService.moduleContent.IsEditable"
                  [checked]="field.IsAlwaysHidden"
                  (change)="toggleAlwaysHidden(field)"
                color="warn"></mat-slide-toggle>
              }
              @if (field.IsMandatory) {
                <mat-icon title="This field is Mandatory, so can't be hidden">
                  warning
                </mat-icon>
              }
            </div>
            <div class="field-detail" (click)="openFieldModalComponent(field)">
              <div>
                <strong [title]="'fieldId: ' + field.FieldId | translate: 'Text' | async">{{field.FieldId | translate: 'Text' | async}}</strong>
              </div>
              <div [title]="'FieldUniqueId: ' + field.FieldUniqueId"><em>{{field.FieldUniqueId }}</em></div>
            </div>
            <div class="field-content" (click)="openFieldModalComponent(field)">
              <div [title]="'FieldName: ' + field.FieldName | translate: 'Text' | async">
                {{field.FieldName | translate: 'Text' | async}}
              </div>
              <div [title]="'HelpText: ' + field.HelpText | translate: 'Text' | async">
                {{field.HelpText | translate: 'Text' | async}}
              </div>
            </div>
            @if (field.IsProtected) {
              <mat-icon class="udq-toggle">fingerprint</mat-icon>
            }
            @if (moduleService.selectedStep.IsAvailableForSwift) {
              <div [matTooltip]="getQuickReportTooltipText(field)">
                <button mat-icon-button
                  [id]="'include-in-swift-toggle-'+field.FieldId"
                  (click)="toggleIncludeInSwift(field)"
                  [ngClass]="{'active': field.IncludeInSwift, 'is-mandatory' : field.IsMandatory}"
                  [disabled]="!isQuickReportToggleEnabled(field)"
                  class="toggle include-in-quick-report">
                  @if (isQuickReportToggleEnabled(field)) {
                    <mat-icon>speed</mat-icon>
                  }
                  @if (!isQuickReportToggleEnabled(field)) {
                    <mat-icon>warning</mat-icon>
                  }
                </button>
              </div>
            }
            <div class="udq-toggle">
              Analytics
              <mat-slide-toggle [checked]="!field.HideOnUdq" (change)="toggleHideOnUdq(field)"></mat-slide-toggle>
            </div>
            @if (field.IsCustomField && moduleService.moduleContent.IsEditable) {
              <div>
                <span>
                  <a mat-raised-button class="mat-accent tableBtn"
                    (click)="fieldService.startEditingCustomField(fieldGroup, field)">
                    <mat-icon>edit</mat-icon>
                  </a>
                  <a mat-raised-button class="mat-warn tableBtn" (click)="fieldService.deleteCustomField(field)">
                    <mat-icon>delete</mat-icon>
                  </a>
                </span>
              </div>
            }
            <div class="right-controls">
              <button mat-icon-button
                (click)="reorderField(fieldGroup.UiGroupName, field, 0)"
                id="field-move-up-{{field.FieldId}}">
                <mat-icon>arrow_drop_up</mat-icon>
              </button>
              <input type="number" id="field-order-{{field.FieldId}}" [value]="field.Order" #fieldOrder (keyup)="orderKeyup.next({group: fieldGroup.UiGroupName, oldpos: field.Order, newpos: +fieldOrder.value})" />
              <button mat-icon-button
                (click)="reorderField(fieldGroup.UiGroupName, field, 1)"
                id="field-move-down-{{field.FieldId}}">
                <mat-icon>arrow_drop_down</mat-icon>
              </button>
              <button mat-icon-button
                [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item
                  (click)="editJson(field)">
                  <mat-icon>code</mat-icon>
                  @if (canEditJson) {
                    <span>Edit JSON Code (UNSAFE)</span>
                  }
                  @if (!canEditJson) {
                    <span>View JSON Code (Readonly)</span>
                  }
                </button>
                @if (displaySetDefaultValueForList(field)) {
                  <button mat-menu-item
                    (click)="setListDefaultValue(field)">
                    <mat-icon>edit</mat-icon>
                    <span>Set Default Value</span>
                  </button>
                }
                @if (field.FieldUniqueId === 'checkbox') {
                  <button mat-menu-item
                    (click)="setCheckBoxDefaultValue(field)">
                    <mat-icon>edit</mat-icon>
                    <span>Set Default Value</span>
                  </button>
                }
                @if (field.FieldUniqueId === 'textbox') {
                  <button mat-menu-item
                    (click)="setTextBoxDefaultValue(field)">
                    <mat-icon>edit</mat-icon>
                    <span>Set Default Value</span>
                  </button>
                }
                @if (field.FieldUniqueId === 'textbox') {
                  <button mat-menu-item
                    (click)="configureLookup(stepId, field.FieldId)">
                    <mat-icon>edit</mat-icon>
                    <span>Configure Lookup</span>
                  </button>
                }
                @if (field.FieldUniqueId === 'linkedrecord') {
                  <button mat-menu-item
                    (click)="configureLinkedRecord(stepId, field)">
                    <mat-icon>edit</mat-icon>
                    <span>Configure Linked Record</span>
                  </button>
                }
                @if (field.FieldUniqueId==='severitymatrix') {
                  <button mat-menu-item
                    (click)="editMatrixName(field)">
                    <mat-icon>edit</mat-icon>
                    <span>Change matrix </span>
                  </button>
                }
                @if (field.FieldUniqueId==='linkedfieldtree') {
                  <button mat-menu-item
                    (click)="editTreeConfiguration(field)">
                    <mat-icon>account_tree</mat-icon>
                    <span>Configure Tree </span>
                  </button>
                }
                @if (isPiiEnabledModule()) {
                  <div>
                    @if (!field.IsProtected) {
                      <button mat-menu-item (click)="toggleProtectedStatus(field)">
                        <mat-icon>fingerprint</mat-icon>
                        <span>Protect PII Field</span>
                      </button>
                    }
                    @if (field.IsProtected) {
                      <button mat-menu-item (click)="exposeField(field)">
                        <span>Unprotect PII field</span>
                      </button>
                    }
                  </div>
                }
              </mat-menu>
            </div>
          </div>
        }
        @if (moduleService.moduleContent && moduleService.moduleContent.IsEditable && !moduleService.selectedStep.IsTemplateStep) {
          <div
            style="margin-top: 15px;margin-bottom: 15px">
            <a mat-raised-button
              class="mat-accent"
              (click)="fieldService.startAddingCustomField(fieldGroup)"
            id="fields-add-field">Add Field</a>
          </div>
        }
      </div>
    }
    @if (moduleService.moduleContent && moduleService.moduleContent.IsEditable && !moduleService.selectedStep.IsTemplateStep) {
      <div
        style="margin-top: 15px;margin-bottom: 15px">
        <div>
          <strong>[EXPERIMENTAL]</strong> Group Name
          <input type="text" id="add-group" [(ngModel)]="newGroupName" (input)="validateNewGroup()" />
          <a mat-raised-button
            class="mat-accent"
            (click)="addNewFieldGroup()"
            [disabled]="addNewGroupIsDisabled"
          id="fields-add-field">Add Group</a>
        </div>
        <div class="state-validation-errors">{{newGroupErrorString}}</div>
      </div>
    }
  </div>
}
